// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".visTableContanier[data-v-359c4282] {\n  width: 100%;\n  height: 100%;\n}\n.visTableContanier[data-v-359c4282] * {\n  outline: none;\n}\n", ""]);
// Exports
module.exports = exports;
